const popup = document.getElementById("quiz-popup");
const closePopupButton = document.getElementById("closePopup");
const actionButton = document.getElementById("action_button");
const startQuiz = document.getElementById("startQuiz");

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}


window.onload = () => {
  var cookieExists = getCookie('popupCookie');
  if (!cookieExists) {
    popup.classList.add("show");
  }
};

closePopupButton.addEventListener("click", () => {
  setCookie("popupCookie",true, 30)
  popup.classList.remove("show");
});

// actionButton.addEventListener("click", () => {
//   popup.classList.add("show");
// });

startQuiz.addEventListener("click", () => {
  setCookie("popupCookie",true, 30)
});

setTimeout(() => {
  actionButton.classList.add("show");
}, "1000");

